import { jsx } from "panel";
import { AsyncButtonEl } from "common/components/async-button";
import { BannerEl } from "common/components/banner";
import { ButtonEl } from "common/components/button";
import { InputEl } from "common/components/input";
import { ModalEl } from "common/components/modal";
import { SelectEl } from "common/components/select";
import { BannerAction, BannerType } from "common/components/banner/types";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { getEntityTypeName } from "common/report/util/saved-entities";
import { SwitchEl } from "common/components/switch";
import { InputLabelEl } from "common/components/input/label";
import { SharingBannerEl } from "../sharing/banner";
export function template() {
  var _this = this;
  const {
    description,
    globalAccessType,
    name,
    saving,
    isCompanyKey,
    companyKeyName
  } = this.state;
  const entityTypeNamePlural = this.getContext("i18n").print(getEntityTypeName(this.attr("entity-type"), {
    plural: true
  }));
  const NameInput = function NameInput2() {
    var _props$placeHolderVal, _props$label;
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return /* @__PURE__ */ jsx(InputEl, { attrs: {
      placeholder: (_props$placeHolderVal = props === null || props === void 0 ? void 0 : props.placeHolderValue) !== null && _props$placeHolderVal !== void 0 ? _props$placeHolderVal : _this.t("components.create-entity.untitled", {
        context: _this.attr("entity-type")
      }),
      label: (_props$label = props === null || props === void 0 ? void 0 : props.label) !== null && _props$label !== void 0 ? _props$label : _this.t("components.create-entity.name"),
      "validation-status": _this.getNameError() ? "invalid" : "",
      "error-message": _this.getNameError() || "",
      elref: "entityNameInput",
      disabled: _this.helpers.isSavingRestricted()
    }, props: {
      value: name
    }, on: {
      input: _this.helpers.handleNameInput,
      keydown: _this.helpers.handleKeydown
    }, hook: {
      insert: (_ref) => {
        let {
          elm
        } = _ref;
        return _this.setElRef("nameInput", elm);
      },
      destroy: () => _this.setElRef("nameInput", null)
    }, "data-sentry-element": "InputEl", "data-sentry-component": "NameInput", "data-sentry-source-file": "template.tsx" });
  };
  const InputDescription = (_ref2) => {
    let {
      text,
      learnMoreLink,
      alignFlexStart
    } = _ref2;
    return /* @__PURE__ */ jsx("div", { sel: ".input-description".concat(alignFlexStart ? "-align-flex-start" : ""), "data-sentry-component": "InputDescription", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".input-description-text" }, text ? text : ""), learnMoreLink ? /* @__PURE__ */ jsx("a", { sel: ".input-description-learn-more".concat(alignFlexStart ? "-align-flex-start" : ""), attrs: {
      href: learnMoreLink,
      target: "_blank"
    } }, this.t("common.learn-more")) : null);
  };
  return /* @__PURE__ */ jsx(ModalEl, { sel: ".modal.create-entity-modal", attrs: {
    open: this.attr("open"),
    role: "dialog",
    title: this.attr("modal-title"),
    closeable: this.attr("closeable"),
    "modal-title": this.attr("modal-title"),
    "modal-description": "Modal for managing ".concat(entityTypeNamePlural)
  }, on: {
    change: this.helpers.handleModalChange
  }, "data-sentry-element": "ModalEl", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-card-header" }, /* @__PURE__ */ jsx("div", { sel: ".mp-card-header-title" }, this.attr("modal-title"))), /* @__PURE__ */ jsx("div", { sel: ".mp-modal-content" }, this.helpers.limitBannerRenderer(), this.helpers.isSavingRestricted() ? /* @__PURE__ */ jsx(BannerEl, { sel: ".banner", attrs: {
    theme: "info",
    type: BannerType.Embedded,
    "header-text": this.t("components.create-entity.cohort-save-upgrade"),
    "body-text": this.t("components.create-entity.cohort-save-upgrade-description"),
    ctas: [{
      text: this.t("common.upgrade"),
      icon: "share",
      actionName: BannerAction.Upgrade
    }],
    "style-override": ".banner-wrapper .banner-panel .banner-copy {width: calc(100% - 130px)}"
  }, on: {
    action: this.helpers.openPricingUpsell
  } }) : /* @__PURE__ */ jsx(null, null, !this.attr("show-global-access-menu") || this.helpers.userLacksSharePermission() ? /* @__PURE__ */ jsx(SharingBannerEl, { sel: ".banner", attrs: {
    "project-id": this.attr("project-id"),
    "entity-type": this.attr("entity-type"),
    "sub-entity-type": this.attr("sub-entity-type")
  } }) : null, this.attr("warning") ? /* @__PURE__ */ jsx(BannerEl, { sel: ".banner", attrs: {
    theme: "warn",
    type: BannerType.Embedded,
    "body-text": this.attr("warning")
  } }) : null), this.attr("entity-type") === "data group" ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(NameInput, { label: this.t("components.create-entity.group-property"), placeHolderValue: this.t("components.create-entity.group-property-placeholder") }), /* @__PURE__ */ jsx(InputDescription, { text: this.t("components.create-entity.group-property-description"), learnMoreLink: "https://help.mixpanel.com/hc/en-us/articles/360025333632#implementation" }), /* @__PURE__ */ jsx(InputEl, { attrs: this.helpers.getDataGroupDescriptionInputAttrs(), props: {
    value: description
  }, on: {
    input: this.helpers.handleDescriptionInput,
    keydown: this.helpers.handleKeydown
  }, hook: {
    insert: (_ref3) => {
      let {
        elm
      } = _ref3;
      return this.setElRef("descriptionTextarea", elm);
    },
    destroy: () => this.setElRef("descriptionTextarea", null)
  } }), this.helpers.isCompanyProfileEnabled() ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(InputDescription, { text: this.t("components.create-entity.group-description") }), /* @__PURE__ */ jsx("div", { sel: ".company-metadata-container" }, /* @__PURE__ */ jsx("div", { sel: ".company-metadata-description-container" }, /* @__PURE__ */ jsx(InputLabelEl, { attrs: {
    label: "Set as Company key"
  } }), /* @__PURE__ */ jsx(InputDescription, { text: "Enables company revenue analytics and company profiles.", learnMoreLink: "https://help.mixpanel.com/hc/en-us/articles/360025333632#implementation", alignFlexStart: true })), /* @__PURE__ */ jsx(SwitchEl, { attrs: {
    on: isCompanyKey
  }, on: {
    change: this.helpers.handleIsCompanyKeyChange
  } })), isCompanyKey ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(InputEl, { attrs: this.helpers.getDataGroupCompanyNameInputAttrs(), props: {
    value: companyKeyName
  }, on: {
    input: this.helpers.handleCompanyKeyNameInput,
    keydown: this.helpers.handleKeydown
  } }), /* @__PURE__ */ jsx(InputDescription, { text: this.t("components.edit-data-group.company-name-description") })) : null) : null) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(NameInput, null), /* @__PURE__ */ jsx(InputEl, { attrs: this.helpers.getDescriptionInputAttrs(), props: {
    value: description
  }, on: {
    input: this.helpers.handleDescriptionInput,
    keydown: this.helpers.handleKeydown
  }, hook: {
    insert: (_ref4) => {
      let {
        elm
      } = _ref4;
      return this.setElRef("descriptionTextarea", elm);
    },
    destroy: () => this.setElRef("descriptionTextarea", null)
  } })), this.helpers.showGlobalAccessMenu() ? /* @__PURE__ */ jsx("div", { sel: ".global-access-container" }, /* @__PURE__ */ jsx("div", { sel: ".label" }, this.t("components.create-entity.who-can-see")), /* @__PURE__ */ jsx(SelectEl, { sel: ".global-access-select", attrs: {
    sections: this.helpers.getGlobalAccessTypeSections(),
    "selected-option": globalAccessType,
    "label-transform": "uppercase",
    size: ButtonSize.Large,
    elref: "globalAccessMenu"
  }, on: {
    change: this.helpers.handleGlobalAccessTypeChange
  } })) : null, /* @__PURE__ */ jsx("div", { sel: ".modal-footer" }, /* @__PURE__ */ jsx("div", { sel: ".modal-actions" }, this.attr("show-share-management") && !this.attr("show-copy-link-button") ? /* @__PURE__ */ jsx("div", { sel: ".modal-actions-confirm-share-container" }, /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: ButtonTheme.Secondary,
    disabled: !this.helpers.formIsValid() || Boolean(saving),
    elref: "saveAndShareButton"
  }, on: {
    click: () => this.helpers.saveChanges(true)
  } }, this.helpers.showGlobalAccessMenu() ? this.t("components.create-entity.customize-access") : this.t("components.create-entity.save-and-share"))) : null, this.attr("show-copy-link-button") && !this.attr("show-share-management") ? /* @__PURE__ */ jsx("div", { sel: ".modal-actions-confirm-share-container" }, /* @__PURE__ */ jsx(AsyncButtonEl, { params: {
    asyncAction: this.helpers.copyLink,
    theme: ButtonTheme.Secondary,
    elref: "copyLinkButton",
    icon: "link"
  } }, this.t("common.copy-url"))) : null, /* @__PURE__ */ jsx("div", { sel: ".modal-actions-cancel-container" }, /* @__PURE__ */ jsx(ButtonEl, { sel: ".modal-actions-cancel", attrs: {
    theme: ButtonTheme.Tertiary,
    elref: "cancelButton"
  }, on: {
    click: this.helpers.handleSaveModalCancel
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, this.t("common.cancel"))), /* @__PURE__ */ jsx("div", { sel: ".modal-actions-confirm-container", on: {
    click: this.helpers.setSubmitAttempted
  } }, /* @__PURE__ */ jsx(
    ButtonEl,
    { sel: ".modal-actions-confirm", attrs: {
      theme: ButtonTheme.Primary,
      disabled: !this.helpers.formIsValid() || Boolean(saving),
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      icon: saving ? "spinner" : "",
      elref: "saveEntityButton"
    }, on: {
      click: () => this.helpers.saveChanges(false)
    }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" },
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    saving ? this.t("common.saving") : this.t("common.save")
  ))))));
}
